import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=4ee6e960"
import script from "./confirm-dialog.vue?vue&type=script&lang=ts"
export * from "./confirm-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports